import type { ReactNode } from 'react';

import { cn } from '@/shared/lib/cn';

type Tone = 'info' | 'success' | 'warning' | 'danger';

const tones: Record<Tone, string> = {
  info: 'bg-info-50 text-info-700 border-info-500/25',
  success: 'bg-success-50 text-success-700 border-success-500/25',
  warning: 'bg-warning-50 text-warning-700 border-warning-500/25',
  danger: 'bg-danger-50 text-danger-700 border-danger-500/25',
};

export function Alert({
  tone = 'info',
  title,
  children,
  className,
}: {
  tone?: Tone;
  title?: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      // Erro e aviso sao anunciados assim que aparecem. Sem isso, quem usa leitor
      // de tela nao percebe que o formulario falhou.
      role={tone === 'danger' ? 'alert' : 'status'}
      className={cn('rounded-md border px-4 py-3 text-sm', tones[tone], className)}
    >
      {title ? <p className="mb-0.5 font-semibold">{title}</p> : null}
      <div className="text-[0.8125rem] leading-relaxed">{children}</div>
    </div>
  );
}
